import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import AddressGroupV2 from 'components/field/AddressGroupV2';
import Alert from 'components/global/Alert';
import Authorization from 'components/global/Authorization';

import useAccessControl from 'hooks/useAccessControl';

import { ACCOUNT_TYPES } from 'utils/constants';

import * as S from './GeneralSettings.styled';

const BillingInfo = ({ isLoading, formFieldName }) => {
	const { watch } = useFormContext();
	const invoiceType = watch('invoiceType');
	const isAuthorized = useAccessControl();

	const isCommonInvoiceTypeCompany = useMemo(
		() => isAuthorized('/company-settings/CommonInvoiceType') && invoiceType === ACCOUNT_TYPES.COMPANY,
		[isAuthorized, invoiceType]
	);

	const isTRClient = useMemo(() => isAuthorized('/company-settings/TRInvoiceType'), [isAuthorized]);

	return (
		<>
			<Authorization path="/company-settings/KSAInvoiceType">
				<Alert content="streetNameShouldBeArabic" variant="warning" showIcon className="my-4" />
			</Authorization>

			<S.AddressContainer>
				<AddressGroupV2
					variants={['fullTextAddress']}
					formFieldName={formFieldName || 'address'}
					isLoading={isLoading}
					formMode="add"
					requiredFields={{
						country: true,
						state: isCommonInvoiceTypeCompany,
						city: isTRClient || invoiceType === ACCOUNT_TYPES.COMPANY,
						street: isCommonInvoiceTypeCompany,
						building: isCommonInvoiceTypeCompany,
						district: isCommonInvoiceTypeCompany
					}}
					labels={{
						building: 'buildingNo'
					}}
				/>
			</S.AddressContainer>
		</>
	);
};

export default BillingInfo;
